import React, { Component, PropTypes } from 'react'
import { Button, Modal } from 'react-bootstrap'
import Styles from './Existing.css'

class DeactivateConfirmModal extends Component {

  render () {
    return (
      <div>
        <Modal
          style={{top: '120px'}}
          show={this.props.show}
          onHide={this._close}
          container={this}
          backdrop='static'
          dialogClassName={Styles['modal-dialog']}
        >
          <Modal.Header className={Styles['modal-header']} closeButton>
            <Modal.Title style={{ fontSize: '19px', fontWeight: '300' }}><div>Deactivate Loyalty Program</div></Modal.Title>
          </Modal.Header>
          <Modal.Body className={`${Styles['modal-body']} top10 bottom10`}>
            Are you sure you want to deactivate the loyalty program? Deactivation will stop the loyalty<br />
            program immediately and customers will not be able to earn nor redeem points.<br /><br />

            <span className={Styles['modal-highlighted-message']}>
              Please make sure all customers & outlets are aware of this deactivation.
            </span>
          </Modal.Body>
          <Modal.Footer>
            <Button style={{width: '100px'}} className='btn btn-default' onClick={this._close}>Cancel</Button>
            <Button style={{width: '100px'}} className='btn btn-danger' onClick={this._onClickDeactivate}>Deactivate</Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }

  _close = (e) => {
    e.stopPropagation()
    this.props.close()
  }

  _onClickDeactivate = (e) => {
    e.stopPropagation()
    this.props.confirm()
  }
}

DeactivateConfirmModal.propTypes = {
  show: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired
}

export default DeactivateConfirmModal



// WEBPACK FOOTER //
// ./app/pages/Customers/Loyalty/Existing/DeactivateConfirmModal.js